import { Phone, Mail, MapPin } from "lucide-react";
import { LOGO_URL, PHONE, PHONE_TEL, EMAIL, LOCATION, AREA } from "@/lib/site-data";

export const Footer = () => {
  return (
    <footer data-testid="site-footer" className="relative bg-black pt-16 pb-8 border-t border-bgtp-line">
      <div className="absolute top-0 left-0 right-0 divider-orange" />
      <div className="max-w-7xl mx-auto px-5 md:px-8">
        <div className="grid md:grid-cols-3 gap-10 pb-10 border-b border-bgtp-line">
          <div>
            <div className="flex items-center gap-3 mb-5">
              <img src={LOGO_URL} alt="BGTP" className="h-14 w-14 object-cover border border-bgtp-line" />
              <div>
                <div className="font-heading text-3xl tracking-wider"><span className="silver-text">BG</span><span className="text-bgtp-orange">TP</span></div>
                <div className="text-[10px] text-bgtp-steel tracking-[0.25em] uppercase">Terrassement · Rénovation</div>
              </div>
            </div>
            <p className="text-sm text-white/65 leading-relaxed max-w-sm">
              Entreprise locale de terrassement, aménagement extérieur et rénovation
              basée à Saint-Didier-sur-Chalaronne. Particuliers & professionnels.
            </p>
          </div>

          <div>
            <div className="text-[10px] tracking-[0.3em] uppercase text-bgtp-orange mb-4">Contact</div>
            <ul className="space-y-3 text-sm">
              <li><a data-testid="footer-phone" href={`tel:${PHONE_TEL}`} className="flex items-center gap-3 text-white/80 hover:text-bgtp-orange"><Phone className="w-4 h-4 text-bgtp-orange" /> {PHONE}</a></li>
              <li><a data-testid="footer-email" href={`mailto:${EMAIL}`} className="flex items-center gap-3 text-white/80 hover:text-bgtp-orange break-all"><Mail className="w-4 h-4 text-bgtp-orange" /> {EMAIL}</a></li>
              <li className="flex items-start gap-3 text-white/80"><MapPin className="w-4 h-4 text-bgtp-orange mt-0.5" /><span>{LOCATION}<br /><span className="text-bgtp-steel text-xs">{AREA}</span></span></li>
            </ul>
          </div>

          <div>
            <div className="text-[10px] tracking-[0.3em] uppercase text-bgtp-orange mb-4">Prestations</div>
            <ul className="grid grid-cols-2 gap-y-2 text-sm text-white/75">
              <li>Terrassement</li>
              <li>Tranchées</li>
              <li>Création de cour</li>
              <li>Aménagement extérieur</li>
              <li>Allées & accès</li>
              <li>Rénovation</li>
              <li>Maçonnerie</li>
              <li>Finitions</li>
            </ul>
          </div>
        </div>

        <div className="pt-6 flex flex-col md:flex-row items-center justify-between gap-3">
          <div className="text-xs text-bgtp-steel tracking-wider uppercase">© {new Date().getFullYear()} BGTP01 — BG Terrassement 01 — Tous droits réservés</div>
          <div className="text-xs text-bgtp-steel">Devis gratuit · Intervention rapide · Travail soigné</div>
        </div>
      </div>
    </footer>
  );
};
